declare global {
  interface Window {
    rdt: any;
  }
}

export const rdt = window.rdt;
